import DOMPurify from "dompurify";
import PropTypes from "prop-types";
import React from "react";

export const SafeHtml = ({ html = "", as: Component = "div", className, style }) => {
    const sanitized = DOMPurify.sanitize(html);

    return (
        <Component
            className={className}
            style={style}
            dangerouslySetInnerHTML={{ __html: sanitized }}
        />
    );
};

SafeHtml.propTypes = {
    html: PropTypes.string,
    as: PropTypes.elementType,
    className: PropTypes.string,
    style: PropTypes.object,
};
